function showProdDetails(ele) {
  let parentDiv = ele.closest(".card_custom");
  let infoBlock = parentDiv.querySelector(".card__content_custom");

  let showDetailsBlocks = document.querySelectorAll(".show_details");
  let productmodal = document.querySelector("#productmodal");

  showDetailsBlocks.forEach((block) => {
    block.classList.remove("show_details");
    block.classList.add("hide_details");
    block
      .closest(".card_custom")
      .querySelector(".btn_show_details").style.display = "grid";
  });

  //infoBlock.classList.remove("hide_details");
  //infoBlock.classList.add("show_details");
  //ele.style.display = "none";

  const screenWidth = window.matchMedia("(max-width: 600px)").matches;

  if (screenWidth) {
    let mobBackground = document.querySelectorAll(".bg-mobile");
    mobBackground.forEach((block) => {
      block.style.display = "none";
    });

    parentDiv.querySelector(".bg-mobile").style.display = "block";
  }

  let errorMsgBox = parentDiv.querySelector('.custom-product-form__error-message-wrapper .custom-product-form__error-message');
  
  if(errorMsgBox.textContent !== ""){
    errorMsgBox.textContent = "";
  }


if(productmodal){
let modalcontent = productmodal.querySelector(".modal-content");

const clonedInfoBlock = infoBlock.cloneNode(true);
modalcontent.innerHTML = ''; // Clear existing content
modalcontent.appendChild(clonedInfoBlock);

// Initialize modal with first variant selected
initializeModalWithFirstVariant(clonedInfoBlock);

    productmodal.style.display = "block";
}
  



  
}

function hideDetailsMob(ele) {
  let parent = ele.closest(".card_custom");
  let infoBlock = parent.querySelector(".card__content_custom");
  infoBlock.classList.add("hide_details");
  infoBlock.classList.remove("show_details");
  parent.querySelector(".btn_show_details").style.display = "grid";
  ele.style.display = "none";
}

// New function to handle variant selection without adding to cart
function selectVariant(ele) {
  let var_id = ele.getAttribute("data-varId");
  let prod_id = ele.getAttribute("data-prodId");
  let variant_price = ele.getAttribute("data-varPrice");
  let variant_compare_price = ele.getAttribute("data-varComparePrice");
  let containingDiv = ele.closest(".card__content_custom");

  console.log("Selecting variant:", {
    var_id,
    prod_id,
    variant_price,
    variant_compare_price
  });

  // Remove selected class from all variants and reset their styles
  let allVariants = containingDiv.querySelectorAll(".variant_options_custom");
  allVariants.forEach(variant => {
    variant.classList.remove("selected");
    // Reset to default styles but keep 12px font size
    variant.style.backgroundColor = "";
    variant.style.color = "#5A4A42"; // Inactive color
    variant.style.border = "";
    variant.style.fontSize = "12px"; // Ensure all variants have 12px font size
  });

  // Add selected class to clicked variant and apply styles directly
  ele.classList.add("selected");
  ele.style.backgroundColor = "#B8A080";
  ele.style.color = "#FFFFFF"; // Selected variant white text
  ele.style.border = "0.5px solid #B8A080";
  ele.style.fontSize = "12px";

  // Store selected variant data
  let hiddenInput = containingDiv.querySelector("input.product-variant-id");
  hiddenInput.value = var_id;
  containingDiv.querySelector("input[name=product-id]").value = prod_id;

  // Update price display
  updateModalPrice(containingDiv, variant_price, variant_compare_price);

  // Enable Add to Cart button
  let addToCartBtn = containingDiv.querySelector(".modal-add-to-cart-btn");
  if (addToCartBtn) {
    addToCartBtn.disabled = false;
    addToCartBtn.style.backgroundColor = "#B8A080";
    addToCartBtn.style.color = "#fff"; // Active button color
    addToCartBtn.style.cursor = "pointer";
    console.log("Add to Cart button enabled successfully");
  } else {
    console.error("Add to Cart button not found in containingDiv");
    console.log("Available buttons:", containingDiv.querySelectorAll("button"));
  }
}

// Function to update price in modal
function updateModalPrice(containingDiv, price, comparePrice) {
  let priceContainer = containingDiv.querySelector(".modal-price-container");
  if (!priceContainer) return;

  // Handle cases where price might be null or undefined
  if (!price) {
    console.warn("Price data not available for variant");
    return;
  }

  // Convert to numbers if they're strings
  let numPrice = parseInt(price);
  let numComparePrice = comparePrice ? parseInt(comparePrice) : null;

  console.log("Price data:", { price, comparePrice, numPrice, numComparePrice });

  let formattedPrice = formatPrice(numPrice);
  let formattedComparePrice = numComparePrice ? formatPrice(numComparePrice) : null;

  let priceHTML = '';

  // Check if there's a discount (compare price exists and is greater than current price)
  if (numComparePrice && numComparePrice > numPrice) {
    // Sale price - Match exact format from price.liquid
    let percentageDiscount = Math.round(((numComparePrice - numPrice) / numComparePrice) * 100);
    priceHTML = `
      <div class="price price--on-sale">
        <div class="price__container">
          <div class="price__sale">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s class="price-item price-item--regular">${formattedComparePrice}</s>
            </span>
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last originalPrice">${formattedPrice}</span>
            <span class="sales_percent">${percentageDiscount}% Off</span>
          </div>
        </div>
      </div>
    `;
  } else {
    // Regular price
    priceHTML = `
      <div class="price">
        <div class="price__container">
          <div class="price__regular">
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span class="price-item price-item--regular">${formattedPrice}</span>
          </div>
        </div>
      </div>
    `;
  }

  priceContainer.innerHTML = priceHTML;
}

// Function to format price using Shopify's money formatting
function formatPrice(priceInCents) {
  // Use Shopify's money formatting if available
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(priceInCents);
  }

  // Fallback formatting to match your store's format (₹ 925+)
  let price = (priceInCents / 100);

  
  return '₹ ' + Math.round(price) ;
}

// Function to add selected variant to cart
function addSelectedVariantToCart(button) {
  let containingDiv = button.closest(".card__content_custom");
  let var_id = containingDiv.querySelector("input.product-variant-id").value;
  let prod_id = containingDiv.querySelector("input[name=product-id]").value;

  if (!var_id) {
    alert("Please select a variant first");
    return;
  }

  // Check variant inventory before adding to cart
  let variables = {
    productId: "gid://shopify/Product/" + prod_id
  };

  const myHeaders = new Headers();
  myHeaders.append(
    "X-Shopify-Storefront-Access-Token",
    "31b83022eb5080bf0d116c47c5298abf"
  );
  myHeaders.append("Content-Type", "application/json");

  const graphql = JSON.stringify({
    query:
      "query GetProduct($productId: ID!) \r\n{\r\n  product(id: $productId) {\r\n    variants(first: 30) {\r\n      nodes {\r\n        id\r\n        quantityAvailable\r\n      }\r\n    }\r\n  }\r\n}",
    variables: variables,
  });
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: graphql,
    redirect: "follow",
  };

  fetch(
    "https://shopindia-ind.myshopify.com/api/2024-01/graphql.json",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => {
      let varArray = result.data.product.variants.nodes;

      if (varArray.length > 0) {
        let matchedVariant = varArray.find((variant) => {
          varIdFetched = variant.id.replace(
            "gid://shopify/ProductVariant/",
            ""
          );
          return varIdFetched === var_id;
        });
        if (matchedVariant) {
          let quantityAvailable = matchedVariant.quantityAvailable;
          if (quantityAvailable > 0) {
            containingDiv.querySelector("button.product-form__submit").click();
          } else {
            alert("This variant is out of stock");
          }
        }
      }
      if(document.getElementById("productmodal")){
        document.getElementById("productmodal").style.display = "none";
      }
    })
    .catch((error) => console.error(error));
}

// Function to initialize the first variant as selected
function initializeFirstVariant(containingDiv) {
  // First, ensure all variants have 12px font size
  let allVariants = containingDiv.querySelectorAll(".variant_options_custom");
  allVariants.forEach(variant => {
    variant.style.fontSize = "12px";
    variant.style.color = "#5A4A42"; // Set inactive color
  });

  // Only select first variant if it's available
  let firstVariant = containingDiv.querySelector(".variant_options_custom.available");
  if (firstVariant) {
    // Trigger selection of first available variant
    selectVariant(firstVariant);
    console.log("First available variant selected");
  } else {
    // If no available variants, don't select any variant
    console.log("No available variants found - no variant selected");

    // Ensure Add to Cart button remains disabled
    let addToCartBtn = containingDiv.querySelector(".modal-add-to-cart-btn");
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.style.backgroundColor = "#ccc";
      addToCartBtn.style.color = "#666";
      addToCartBtn.style.cursor = "not-allowed";
      console.log("Add to Cart button kept disabled - no available variants");
    }
  }
}

// Function to initialize modal with first variant selected (backward compatibility)
function initializeModalWithFirstVariant(modalContent) {
  initializeFirstVariant(modalContent);
}

// Keep the old function for backward compatibility (if needed elsewhere)
function sendData(ele) {
  // This function is now deprecated in favor of selectVariant
  selectVariant(ele);
}
